var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-outer"},[_c('div',{staticClass:"page-contents mx-auto"},[_c('div',{staticClass:"vendors"},_vm._l((_vm.filteredVendors),function(vendor){return _c('RouterLink',{key:vendor.title,staticClass:"!text-none",attrs:{"to":vendor.to}},[_c('VenCard',{attrs:{"vendor":vendor}})],1)}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }